<template>
  <div>
    <section class="public-view-landing-content pass-view-landing-container">
      <div class="d-flex flex-md-row flex-column justify-content-center">
        <div class="col-md-5 flex-col company-col-container">
          <img
            :src="companyLogo"
            alt="Company Logo"
            width="160px"
            height="160px">
          <h2>{{ companyName }}</h2>
        </div>

        <div v-bind:class="[columnDetailsWidth, 'flex-col']">
          <div class="data-row">
            <label>Pass Name:</label>
            <p>{{ passDetail.pass_name }}</p>
          </div>

          <div class="data-row">
            <label>Pass owner:</label>
            <p>{{ passDetail.company_name }}</p>
          </div>

          <div class="data-row">
            <label>Valid from:</label>
            <p>{{ passDetail.visiting_date }}, {{ passDetail.visiting_time }}</p>
          </div>

          <div class="data-row">
            <label>Valid until:</label>
            <p>{{ passDetail.validity_date }}, {{ passDetail.validity_time}}</p>
          </div>

          <div class="data-row" v-if="passDetail.disposal_date === '1 months'">
            <label>Pass disposal in:</label>
            <p>1 month</p>
          </div>

          <div class="data-row" v-else-if="passDetail.disposal_date === '1 years'">
            <label>Pass disposal in:</label>
            <p>1 year</p>
          </div>

          <div class="data-row" v-else>
            <label>Pass disposal in:</label>
            <p>{{ passDetail.disposal_date }}</p>
          </div>

          <div class="data-row">
            <label>Building Name:</label>
            <p>{{ passDetail.building_name }}</p>
          </div>

          <div class="data-row">
            <label>Building Address:</label>
            <p>{{ passDetail.building_address }}</p>
          </div>

          <div class="data-row">
            <label>Reason for visit:</label>
            <p>{{ passDetail.reason_for_visit }}</p>
          </div>

          <div class="data-row">
            <label>Agreements:</label>

            <div v-for="d in passDetail.agreements_data" :key="d.id">
              <p v-if="d.other_agreement_name !== 'none'">
                {{ d.other_agreement_name }} -
                <a target="_blank" :href="getAgreementLink(d.ref_code)" class="simple-link">
                  VIEW
                </a>
              </p>
              <p v-else>
                {{ d.agreement_name }} -
                <a target="_blank" :href="getAgreementLink(d.ref_code)" class="simple-link">
                  VIEW
                </a>
              </p>
              <!-- <p>
                <a target="_blank" :href="getAgreementLink(d.ref_code)" class="simple-link">
                  {{ getAgreementLink(d.ref_code) }}
                </a>
              </p> -->
            </div>

            <div v-if="isToVerifyIdentity">
              <p>Identification card</p>
              <p>
                <label>
                Your id card will be shared to {{ passDetail.company_name }}
                in case any security concerns arises.More details
                <a href="#">here</a>
                </label>
              </p>
            </div>
          </div>

          <div class="data-row">
            <label>Shared details:</label>
            <div v-for="(data, index) in passDetail.included_pass_details" :key="index">
              <p>{{ data }}</p>
            </div>
          </div>
        </div>
        <!--END 2nd column-->
        <div v-if="hasQR && passDetail.status ==='Active' || passDetail.status === 'Pending'"
          class="col-md-2 flex-col qr-code-container">
          <img :src="qrcode" width="120px" height="120px"/>
        </div>

        <!-- SERVES AS PADDING-->
        <div v-if="hasQR && passDetail.status !=='Active' || passDetail.status !== 'Pending'"
          class="col-md-1">
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.pass-view-landing-container {
  background-color: #f2f9ff;
}

/deep/ h2 {
  font-size: 25px;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
</style>

<script>
import QRCode from 'qrcode'

export default {
  props: {
    qrcodeValue: {
      type: String,
      required: true
    },
    passDetail: {
      type: Object,
      required: true
    },
    hasQR: {
      type: Boolean,
      default: false
    },
    isToVerifyIdentity: Boolean,
    userProfileDetails: Object,
    userEmailAddress: String,
    companyLogo: String,
    companyName: String
  },
  computed: {
    columnDetailsWidth: function() {
      if (this.hasQR) {
        return 'col-md-5'
      }
      return 'col-md-6'
    }
  },
  data() {
    return {
      qrcode: '',
      errMsg: ''
    }
  },
  mounted() {
    QRCode.toDataURL(this.qrcodeValue)
    .then(url => { this.qrcode = url })
    .catch(err => { this.errMsg = err })
  },
  methods: {
    getAgreementLink(link) {
      const url = `${window.location.origin}/agreements/view/${link}`
      return url
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/share/passes/PassShareViewDetails.vue